<template>
  <div>
    <div class="col-9 ms-auto me-5 px-3">
      <div class="col-12 d-flex justify-content-between align-items-end p-0 my-4">
        <span class="body-title">Lista de gastos</span>

        <div>
          <button
            id="modal-open"
            type="button"
            class="btn btn-success"
            data-bs-toggle="modal"
            data-bs-target="#addOrEditSpend"
          >
            <i class="fa-solid fa-plus me-2"></i>
            Agregar gasto
          </button>
        </div>
      </div>

      <div class="content-view">
        <paginate
          ref="paginator"
          name="elements"
          :list="allSpends"
          :per="15"
          :async="true"
        >
          <div class="col-5 my-2">
            <input
              type="text"
              class="form-control"
              placeholder="Buscar gasto(s)"
              v-model="spendSearch"
              @keyup="getAll()"
            />
          </div>

          <table class="table table-hover mt-3">
            <thead>
              <th class="col">Cantidad</th>
              <th class="col">Nombre</th>
              <th class="col ps-2">Precio</th>
              <th class="col ps-2">Total</th>
            </thead>

            <tbody class="position-relative">
              <tr
                v-for="(spend, i) in paginated('elements')"
                :key="i"
                @click="openModalForEdit(spend)"
                :id="`spend-row-${i}`"
                @mouseenter="addOrRemoveDeleteOptClass($event)"
                @mouseleave="addOrRemoveDeleteOptClass($event)"
              >
                <td>{{ spend.quantity }}</td>
                <td>{{ spend.name }}</td>
                <td>{{ spend.price }}</td>
                <td>{{ formatNumber(spend.total) }}</td>
                <td class="deleteOpt text-danger" @click.stop="confirmDeleteMessage(spend)">
                  <i class="bi bi-trash-fill"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </paginate>

        <div>
          <paginate-links
            for="elements"
            :limit="9"
            :hide-single-page="true"
            :show-step-links="true"
            :step-links="{
              next: '  ❯',
              prev: '❮  ',
            }"
          >
          </paginate-links>
        </div>
      </div>

      <!-- Modals -->
      <!-- Add or Edit spend -->
      <div
        class="modal fade"
        id="addOrEditSpend"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title fw-bold">{{ spend.id ? "Editar gasto" : "Agregar gasto" }}</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body">
              <form @submit.prevent="spend.id ? updateSpend() : createSpends()">
                <div class="d-flex justify-content-around col-12 my-2">
                  <table class="table mt-3">
                    <thead>
                      <th class="col-1">Cantidad</th>
                      <th class="col-5">Nombre</th>
                      <th class="col-2">Precio</th>
                      <th class="col-1 text-center">Total</th>
                      <th class="col-1"></th>
                    </thead>

                    <tbody v-if="!spend.id" class="position-relative">
                      <tr v-for="(spend, i) in spendsToAdd" :key="i"
                        :id="`new-spend-row-${i}`"
                        @mouseenter="addOrRemoveDeleteOptClass($event)"
                        @mouseleave="addOrRemoveDeleteOptClass($event)"
                      >
                        <td class="p-0 pe-3 border-bottom-0">
                          <input
                            @keydown.enter="enterAsTab"
                            @focus="selectText($event)"
                            @input="updateTotal(spend)"
                            type="number"
                            class="form-control col-6 text-center"
                            v-model="spend.quantity"
                            required
                          />
                        </td>

                        <td class="p-0 pe-3 border-bottom-0">
                          <input
                            @keydown.enter="enterAsTab"
                            @input="updateTotal(spend)"
                            type="text"
                            class="form-control col-6"
                            v-model="spend.name"
                            required
                          />
                        </td>

                        <td class="p-0 pe-3 border-bottom-0">
                          <CurrencyInput
                            @keydown.enter="enterAsTab"
                            @input="updateTotal(spend)"
                            type="text"
                            class="form-control col-6 text-center"
                            v-model="spend.price"
                            required
                          ></CurrencyInput>
                        </td>

                        <td class="d-flex fw-bold justify-content-center border-bottom-0">
                          <div class="text-center">
                            {{ formatNumber(spend.total) }}
                          </div>
                        </td>

                        <td class="border-bottom-0 ">
                          <div class="d-flex justify-content-around col-8 deleteOpt">
                            <div v-if="i == spendsToAdd.length -1" @click.stop="addNewSpend()">
                              <i class="fa-solid fa-plus fs-5 text-primary"></i>
                            </div>

                            <div v-if="i != spendsToAdd.length -1 || spendsToAdd.length > 1" @click.stop="confirmDeleteMessage(spend)">
                              <i class="bi bi-trash-fill fs-5 text-danger"></i>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>

                    <tbody v-else class="position-relative">
                      <tr>
                        <td class="p-0 pe-3 border-bottom-0">
                          <input
                            @keydown.enter="enterAsTab"
                            @focus="selectText($event)"
                            @input="updateTotal(spend)"
                            type="number"
                            class="form-control col-6 text-center"
                            v-model="spend.quantity"
                            required
                          />
                        </td>

                        <td class="p-0 pe-3 border-bottom-0">
                          <input
                            @keydown.enter="enterAsTab"
                            @input="updateTotal(spend)"
                            type="text"
                            class="form-control col-6"
                            v-model="spend.name"
                            required
                          />
                        </td>

                        <td class="p-0 pe-3 border-bottom-0">
                          <CurrencyInput
                            @keydown.enter="enterAsTab"
                            @input="updateTotal(spend)"
                            type="text"
                            class="form-control col-6 text-center"
                            v-model="spend.price"
                            required
                          ></CurrencyInput>
                        </td>

                        <td class="d-flex fw-bold justify-content-center border-bottom-0">
                          <div class="text-center">
                            {{ formatNumber(spend.total) }}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="modal-footer">
                  <section>
                    <button type="submit" class="btn btn-success" aria-label="Close">
                      {{ spend.id ? "Actualizar gasto" : "Añadir gasto" }}
                    </button>
                  </section>

                  <button
                    id="modal-close"
                    type="button"
                    class="btn btn-danger"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    @click="clearFormVariables()"
                  >
                    Cerrar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import VuePaginate from "vue-paginate";
import CurrencyInput from "../CurrencyInputComponent.vue";

  export default {
    components: {
      VuePaginate,
      CurrencyInput,
    },
    data(){
      return {
        allSpends      : [],
        spendsToAdd : [{
          id       : null,
          name     : "",
          price    : "0",
          quantity : "1",
          total    : "0.00",
        }],
        spend     : {
          id       : null,
          name     : "",
          price    : "0",
          quantity : "1",
          total    : "0.00",
        },
        spendSearch : null,
        paginate    : ["elements"],
      }
    },
    methods:{
      getAll(){
        axios.get('spend/get-all', {
          params: {
            "search" : this.spendSearch
          }
        }).then(response => {
          this.allSpends = response.data.spends
          this.$refs.paginator.currentPage = 0;
        })
      },

      clearFormVariables(){
        this.spendsToAdd = [{
          id       : null,
          name     : "",
          price    : "0",
          quantity : "1",
          total    : "0.00",
        }]

        this.spend = {
          id       : null,
          name     : "",
          price    : "0",
          quantity : "1",
          total    : "0.00",
        }
      },
      /**  Add new spend object to spendsToAdd variable */
      addNewSpend(){
        this.spendsToAdd.push({
          id       : null,
          name     : "",
          price    : "0",
          quantity : "1",
          total    : "0",
        })
      },
      /**
       * Message delete confirmation
       */
      confirmDeleteMessage(spend) {
        Swal.fire({
          title: `¿Deseas eliminar este gasto?`,
          showDenyButton: true,
          confirmButtonText: "Sí",
        }).then((response) => {
          if(response.isConfirmed){
            (spend.id)
              ? this.deleteSpend(spend)
              : this.removeSpendToAdd(spend);
          }
        });
      },

      deleteSpend(spend){
        axios.delete(`/spend/${spend.id}`,spend)
        .then((response) => {
          if(response.data.success){
            this.getAll();

            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              title: response.data.success,
            });

            this.spendSearch = null;
            this.clearFormVariables();
          }
        })
      },

      openModalForEdit(spend) {
        this.spend = spend;
        this.openModal();
      },

      /**
       * Open add or edit modal
       */
      openModal() {
        const myModal = new bootstrap.Modal(document.querySelector("#addOrEditSpend"), {});
        myModal.show();
      },

      /**
       * Remove spend from spendsToAdd variable
       */
      removeSpendToAdd(spend){
        let index = this.spendsToAdd.findIndex(el => el == spend);
        if (index > -1) this.spendsToAdd.splice(index, 1); // deleting
      },

      updateTotal(spend){
        spend.total = +spend.quantity * spend.price;
      },
      /** Create spend registries */
      createSpends(){
        axios.post('/spend', this.spendsToAdd)
        .then(response => {
          if(response.data.success){
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              title: response.data.success,
            });
            document.getElementById('modal-close').click();
            this.getAll();
            this.clearFormVariables();
          }
        })
      },

      updateSpend(){
        axios.put(`/spend/${this.spend.id}`,this.spend)
        .then(response => {
          if(response.data.success){
            this.getAll();

            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              title: response.data.success,
            });

            this.spendSearch = null;
            document.getElementById('modal-close').click();
          }
        })
      }
    },

    created(){
      this.getAll();
    }
  }
</script>

<style lang="scss">
// tr:hover{
//   .deleteOpt{
//     opacity: 1;
//   }
// }
</style>
